import * as React from "react";
const SvgFiRrClockUpArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-clock-up-arrow_svg__a)">
      <path
        fill="#062147"
        d="M12 5a1 1 0 0 1 1 1v5.876a1 1 0 0 1-.479.854l-4.408 2.696a.999.999 0 0 1-1.375-.333 1 1 0 0 1 .332-1.375L11 11.315V6a1 1 0 0 1 1-1m10 8h-4a1 1 0 1 0 0 2h2.568l-4.329 4.328a.53.53 0 0 1-.729 0l-1.104-1.104c-.951-.953-2.608-.953-3.562 0l-4.053 4.07a1.001 1.001 0 0 0 1.418 1.412l4.052-4.07a.53.53 0 0 1 .729 0l1.104 1.104c.951.953 2.61.952 3.56 0L22 16.395v2.604a1 1 0 1 0 2 0v-4c0-1.103-.897-2-2-2zM2 12C2 6.486 6.486 2 12 2a9.99 9.99 0 0 1 9.835 8.181.994.994 0 0 0 1.164.803 1 1 0 0 0 .803-1.164A11.99 11.99 0 0 0 12 0C5.383 0 0 5.383 0 12c0 3.316 1.392 6.516 3.818 8.778a.995.995 0 0 0 1.413-.049 1 1 0 0 0-.05-1.413 10.04 10.04 0 0 1-3.182-7.315z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-clock-up-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrClockUpArrow;
